import { render, staticRenderFns } from "./app-update-required-modal.vue?vue&type=template&id=242e976c&"
import script from "./app-update-required-modal.vue?vue&type=script&lang=js&"
export * from "./app-update-required-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports